import { render } from "./UiModalFooter.vue?vue&type=template&id=6d015cc3"
import script from "./UiModalFooter.vue?vue&type=script&lang=js"
export * from "./UiModalFooter.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__